var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.602 4.61h1.344v3.36H5.602V4.61Zm0 4.031h1.343v1.344H5.602V8.64Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.463.713A1.342 1.342 0 0 0 6.275 0c-.498 0-.954.273-1.187.714l-4.93 9.313a1.335 1.335 0 0 0 .036 1.323 1.332 1.332 0 0 0 1.15.65h9.862c.475 0 .906-.243 1.151-.65a1.335 1.335 0 0 0 .037-1.322L7.462.713Zm-6.118 9.943 4.93-9.313 4.934 9.313H1.345Z",
    fill: "currentColor"
  })));
};
export default SvgError;